import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { OneTimePaySetup } from '@amfam/billing/one-time-pay/feature';

@Component({
  selector: 'amfam-account-description-minimal',
  templateUrl: './account-description-minimal.component.html',
  styleUrls: ['./account-description-minimal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class AccountDescriptionMinimalComponent {
  @Input() option: OneTimePaySetup;

  constructor() {}
}
